import { Label, Message } from 'semantic-ui-react';
import { getChannelOption } from './helper';
import React from 'react';

export function renderText(text, limit) {
  if (text.length > limit) {
    return text.slice(0, limit - 3) + '...';
  }
  return text;
}

export function renderGroup(group) {
  if (group === '') {
    return <Label>default</Label>;
  }
  let groups = group.split(',');
  groups.sort();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '2px',
        rowGap: '6px',
      }}
    >
      {groups.map((group) => {
        if (group === 'vip' || group === 'pro') {
          return <Label color='yellow'>{group}</Label>;
        } else if (group === 'svip' || group === 'premium') {
          return <Label color='red'>{group}</Label>;
        }
        return <Label>{group}</Label>;
      })}
    </div>
  );
}

export function renderNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

// 与后端 relay/billing/pricing/pricing.go 的 QuotaPerYuan 保持一致。
// 注意：后端该常量为硬编码，不随 options 中的 QuotaPerUnit 变化
// （见 docs/dev-logs/2026-10-15-011 第五节第 1 条），因此前端缺值时
// 只能回退到这个值，不能回退到 1 —— 回退到 1 会把金额放大 500000 倍。
const DEFAULT_QUOTA_PER_UNIT = 500000;

function getQuotaPerUnit() {
  const parsed = parseFloat(localStorage.getItem('quota_per_unit'));
  // 必须校验 > 0：0 会产生 Infinity，NaN 会污染整张表格
  if (Number.isFinite(parsed) && parsed > 0) {
    return parsed;
  }
  return DEFAULT_QUOTA_PER_UNIT;
}

// 原始 quota -> 元。返回 null 表示无法换算，由调用方决定降级展示。
export function quotaToYuan(quota) {
  const n = Number(quota);
  if (!Number.isFinite(n)) {
    return null;
  }
  return n / getQuotaPerUnit();
}

// 非零但按指定精度四舍五入后会变成 0 时，逐步提高精度，
// 避免「真扣了钱却显示 ¥0.00」。上限 6 位，与日志明细精度对齐。
function formatAmount(yuan, precision) {
  if (yuan === 0) {
    return (0).toFixed(precision);
  }
  let p = precision;
  while (p < 6 && Number(yuan.toFixed(p)) === 0) {
    p += 1;
  }
  return yuan.toFixed(p);
}

export function renderQuota(quota, t, precision = 2) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const yuan = quotaToYuan(quota);

  if (displayInCurrency && yuan !== null) {
    return t('common.quota.display_short', {
      amount: formatAmount(yuan, precision),
    });
  }

  return renderNumber(quota);
}

export function renderQuotaWithPrompt(quota, t) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const yuan = quotaToYuan(quota);

  if (displayInCurrency && yuan !== null) {
    return ` (${t('common.quota.display', {
      amount: formatAmount(yuan, 2),
    })})`;
  }

  return '';
}

// 用于「单位已是万」的数值（后端 dashboard.go / dashboard_ranking.go 已 /10000）。
// 不要再用 renderNumber：它会做 B/M/k 二次缩写，导致 25000(万) 显示成 "25.0k"，
// 配上「(万)」表头读作 25000 万；拼上 ' 万' 后更会得到 "25.0k 万" 这种矛盾单位。
export function renderWan(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '-';
  }
  return n.toLocaleString('zh-CN', { maximumFractionDigits: 1 });
}

// 入参必须是**已换算为元**的值（如 /api/dashboard/ranking 返回的 cur_quota、
// /api/dashboard/trend 返回的 quota_cost），不要再除以 quota_per_unit。
// 需要把原始 quota 换算成元时，请用 quotaToYuan / renderQuota。
export function renderYuan(value, precision = 2) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return '-';
  }
  return (
    '¥' +
    n.toLocaleString('zh-CN', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    })
  );
}

const colors = [
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
];

export function renderColorLabel(text) {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  let index = Math.abs(hash % colors.length);
  return (
    <Label basic color={colors[index]}>
      {text}
    </Label>
  );
}

export function renderChannelTip(channelId) {
  let channel = getChannelOption(channelId);
  if (channel === undefined || channel.tip === undefined) {
    return <></>;
  }
  return (
    <Message>
      <div dangerouslySetInnerHTML={{ __html: channel.tip }}></div>
    </Message>
  );
}
